import { Button } from '@/components/ui';
import type { PageTourKey } from '@/lib/tours/registry';
import { usePageHelpPopover } from './PageHelpPopover';
import { usePageTourActions } from './PageTourHost';
import { schedulePageTourStart } from '@/lib/tours/scheduleAutoPageTour';
import { startTourFromPopover } from './startTourFromPopover';

interface PageTourHelpProps {
  tourKey: PageTourKey;
  children?: React.ReactNode;
  buttonLabel?: string;
  onBeforeStart?: () => void;
  onStart?: () => void;
}

export function PageTourHelp({
  tourKey,
  children,
  buttonLabel = 'Start tour',
  onBeforeStart,
  onStart,
}: PageTourHelpProps) {
  const { startPageTour } = usePageTourActions();
  const closePageHelp = usePageHelpPopover();

  const handleStartTour = () => {
    onBeforeStart?.();
    if (onStart) {
      closePageHelp();
      onStart();
      return;
    }
    if (onBeforeStart) {
      closePageHelp();
      schedulePageTourStart(
        (key) => startPageTour(key, { skipWelcomeDialog: true }),
        tourKey,
      );
      return;
    }
    startTourFromPopover(startPageTour, tourKey, closePageHelp);
  };

  return (
    <div className="space-y-3 text-sm text-muted-foreground">
      {children}
      <Button
        type="button"
        variant="outline"
        size="sm"
        onPointerDown={(event) => {
          event.preventDefault();
        }}
        onClick={handleStartTour}
      >
        {buttonLabel}
      </Button>
    </div>
  );
}
